export function serialize(target: string | undefined) {
  return JSON.stringify(target).slice(1, -1);
}
